/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * IconButton CSS
 */
export const styles = css`
  :host {
    display: inline-block;
    color:  var(--nile-colors-neutral-700);
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: var(--nile-radius-sm);
    font-size: inherit;
    color: inherit;
    padding: var(--nile-radius-md);
    cursor: pointer;
    transition: 50ms;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: var(--nile-colors-blue-500)
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: hsl(201.3 96.3% 32.2%);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: hsl(200.4 98% 39.4%);
    outline-offset: 1px;
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;

export default [styles];
